import { Navigate, Route, Routes } from "react-router-dom";

import RequireAuth from "@/components/Layout/RequireAuth";
import Activate from "@/routes/Activate";
import Admin from "@/routes/Admin";
import AuditReport from "@/routes/AuditReport";
import CourseEditor from "@/routes/CourseEditor";
import CourseList from "@/routes/CourseList";
import CourseOverview from "@/routes/CourseOverview";
import CourseWorkspace from "@/routes/CourseWorkspace";
import Extract from "@/routes/Extract";
import Login from "@/routes/Login";
import Forgot from "@/routes/Forgot";
import ResetPassword from "@/routes/ResetPassword";
import Privacy from "@/routes/Privacy";
import Register from "@/routes/Register";
import Wizard from "@/routes/Wizard";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/datenschutz" element={<Privacy />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <CourseList />
          </RequireAuth>
        }
      />
      <Route
        path="/extract"
        element={
          <RequireAuth>
            <Extract />
          </RequireAuth>
        }
      />
      <Route
        path="/new"
        element={
          <RequireAuth>
            <Wizard />
          </RequireAuth>
        }
      />
      <Route
        path="/courses/:id"
        element={
          <RequireAuth>
            <CourseOverview />
          </RequireAuth>
        }
      />
      <Route
        path="/courses/:id/workspace"
        element={
          <RequireAuth>
            <CourseWorkspace />
          </RequireAuth>
        }
      />
      <Route
        path="/courses/:id/edit"
        element={
          <RequireAuth>
            <CourseEditor />
          </RequireAuth>
        }
      />
      <Route
        path="/courses/:id/audit/:reportId"
        element={
          <RequireAuth>
            <AuditReport />
          </RequireAuth>
        }
      />
      <Route
        path="/activate"
        element={
          <RequireAuth>
            <Activate />
          </RequireAuth>
        }
      />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <Admin />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
